/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAccountInternal} from '../api'

 export const useQueryGetAccountInternal = createReactQueryHook('getAccountInternal', getAccountInternal)
